export default "__VITE_ASSET__BXMnNJsZ__"